import { getParametrizedUrl } from '@x_x_x/utils';

import { URLS_API } from '@constants';

import { BaseApi, IRequestOptions } from '../BaseApi';

import {
	IApiMenuFetchListRequestParams,
	IApiMenuFetchListResponseData,

	IApiMenuCreateRequestParams,
	IApiMenuCreateRequestBody,
	IApiMenuCreateResponseData,

	IApiMenuUpdateRequestParams,
	IApiMenuUpdateRequestBody,
	IApiMenuUpdateResponseData,
} from './types';

export class MenuApi extends BaseApi {

	async fetchList(options: IRequestOptions<IApiMenuFetchListRequestParams>) {
		const { params } = options;

		return this.get<IApiMenuFetchListRequestParams, IApiMenuFetchListResponseData>({
			url: getParametrizedUrl(URLS_API.MENU),
			params,
		});
	}

	async create(options: IRequestOptions<IApiMenuCreateRequestParams, IApiMenuCreateRequestBody>) {
		const { body } = options;

		return this.post<IApiMenuCreateRequestBody, IApiMenuCreateResponseData>({
			url: getParametrizedUrl(URLS_API.MENU),
			data: body,
		});
	}

	async update(options: IRequestOptions<IApiMenuUpdateRequestParams, IApiMenuUpdateRequestBody>) {
		const { params, body } = options;

		return this.put<IApiMenuUpdateRequestBody, IApiMenuUpdateResponseData>({
			url: getParametrizedUrl(URLS_API.MENU_ITEM, params as unknown as Record<string, string>),
			data: body,
		});
	}

}
